export function getOfficemailDomain() {
  const domain = (process.env.REACT_APP_TARGET === 'production') ? 'officemail.io' : 'officemail.app';
  return domain;
}

export function getMXValue() {
  const mxValue = (process.env.REACT_APP_TARGET === 'production') ? 'mx.officemail.io' : 'mxdev.officemail.app';
  return mxValue;
}

const info = {
  getOfficemailDomain,
  getMXValue,
}

export default info;
